import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideLiteracyModal, showLiteracyModal } from 'actions/app-state';
import { useHistory } from 'react-router-dom';
import { HomeroomProps } from 'utils/helpers/resourcesMap';
import StaticMapElements from 'components/common/staticMapElements';
import {
  mapStaticElements,
  mapStaticRooms,
} from 'utils/helpers/resourcesMapRenderers';
import { defaultMapTemplate } from 'utils/constants/map';
import MobileService from 'services/mobile';

let literacyModalIssuer: string | undefined;

const Homeroom: React.FC<HomeroomProps> = ({
  dRMapLinkElements,
  literacyModalResult,
  scholar,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const mapTemplate = scholar?.settings?.mapTemplate || defaultMapTemplate;

  const openLiteracyModal = useCallback(
    (url: string) => {
      literacyModalIssuer = url;
      dispatch(showLiteracyModal());
    },
    [dispatch]
  );

  useEffect(() => {
    if (literacyModalResult && literacyModalIssuer) {
      dispatch(hideLiteracyModal());

      if (
        literacyModalIssuer === '/process-steps-admin' &&
        MobileService.isMobile
      ) {
        literacyModalIssuer = '/dashboard/scholars';
      }

      history.push(literacyModalIssuer);
      literacyModalIssuer = undefined;
    }
  }, [literacyModalResult, history, dispatch]);

  const StaticRooms = mapStaticRooms[mapTemplate];
  const StaticElements = mapStaticElements[mapTemplate];

  return (
    <g className={`digital-resources-map ${mapTemplate && mapTemplate}`}>
      <StaticMapElements
        scholar={scholar}
        staticElements={<StaticElements />}
      />
      {dRMapLinkElements}
      <StaticRooms openLiteracyModal={openLiteracyModal} />
    </g>
  );
};

export default Homeroom;
